var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showWidget
    ? _c(
        "div",
        { staticClass: "sipinor-ai-widget" },
        [
          _c("transition", { attrs: { name: "sipinor-ai-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.panelOpen,
                    expression: "panelOpen",
                  },
                ],
                staticClass: "sipinor-ai-panel",
                class: [
                  {
                    "sipinor-ai-panel--dark": _vm.isDark,
                    "sipinor-ai-panel--expanded": _vm.panelExpanded,
                  },
                  _vm.mode === "action"
                    ? "sipinor-ai-panel--mode-action"
                    : "sipinor-ai-panel--mode-suggestion",
                ],
                attrs: { role: "dialog", "aria-label": "AI assistant" },
              },
              [
                _c("div", { staticClass: "sipinor-ai-panel__head" }, [
                  _c("div", { staticClass: "sipinor-ai-panel__brand" }, [
                    _c(
                      "div",
                      {
                        staticClass: "sipinor-ai-panel__avatar",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              viewBox: "0 0 24 24",
                              width: "22",
                              height: "22",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M12 2a4 4 0 0 1 4 4v1a4 4 0 1 1-8 0V6a4 4 0 0 1 4-4z",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "sipinor-ai-panel__titles" }, [
                      _c(
                        "div",
                        { staticClass: "sipinor-ai-panel__title-row" },
                        [
                          _c(
                            "span",
                            { staticClass: "sipinor-ai-panel__title" },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.ai_assistant"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "sipinor-ai-panel__mode-chip",
                              class:
                                _vm.mode === "action"
                                  ? "sipinor-ai-panel__mode-chip--action"
                                  : "sipinor-ai-panel__mode-chip--suggestion",
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.mode === "action"
                                      ? _vm.trans(
                                          "configuration.ai_assistant_action_mode"
                                        )
                                      : _vm.trans(
                                          "configuration.ai_assistant_suggestion_mode"
                                        )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "sipinor-ai-panel__subtitle" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.mode === "action"
                                ? _vm.trans(
                                    "configuration.ai_assistant_panel_subtitle_action"
                                  )
                                : _vm.trans(
                                    "configuration.ai_assistant_panel_subtitle_suggestion"
                                  )
                            ) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sipinor-ai-panel__head-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "sipinor-ai-panel__icon-btn sipinor-ai-panel__icon-btn--expand",
                        attrs: {
                          type: "button",
                          title: _vm.panelExpanded
                            ? _vm.trans(
                                "configuration.ai_assistant_shrink_panel"
                              )
                            : _vm.trans(
                                "configuration.ai_assistant_expand_panel"
                              ),
                          "aria-label": _vm.panelExpanded
                            ? _vm.trans(
                                "configuration.ai_assistant_shrink_panel"
                              )
                            : _vm.trans(
                                "configuration.ai_assistant_expand_panel"
                              ),
                        },
                        on: { click: _vm.togglePanelExpanded },
                      },
                      [
                        !_vm.panelExpanded
                          ? _c("em", {
                              staticClass: "icon ni ni-maximize",
                              attrs: { "aria-hidden": "true" },
                            })
                          : _c("em", {
                              staticClass: "icon ni ni-minimize",
                              attrs: { "aria-hidden": "true" },
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "sipinor-ai-panel__icon-btn",
                        attrs: {
                          type: "button",
                          title: _vm.trans(
                            "configuration.ai_assistant_clear_chat"
                          ),
                          "aria-label": _vm.trans(
                            "configuration.ai_assistant_clear_chat"
                          ),
                        },
                        on: { click: _vm.startNewChat },
                      },
                      [_c("em", { staticClass: "icon ni ni-trash" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "sipinor-ai-panel__icon-btn",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.trans("general.close"),
                        },
                        on: { click: _vm.closePanel },
                      },
                      [_c("em", { staticClass: "icon ni ni-cross" })]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sipinor-ai-panel__toolbar" }, [
                  _c(
                    "div",
                    {
                      staticClass: "sipinor-ai-segmented",
                      attrs: { role: "group" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "sipinor-ai-segmented__btn",
                          class: { "is-active": _vm.mode === "suggestion" },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.setMode("suggestion")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.trans(
                                  "configuration.ai_assistant_suggestion_mode"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "sipinor-ai-segmented__btn",
                          class: { "is-active": _vm.mode === "action" },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.setMode("action")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.trans(
                                  "configuration.ai_assistant_action_mode"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "sipinor-ai-segmented__btn sipinor-ai-segmented__btn--icon",
                          attrs: {
                            type: "button",
                            title: _vm.trans(
                              "configuration.ai_assistant_history"
                            ),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleHistory.apply(null, arguments)
                            },
                          },
                        },
                        [_c("em", { staticClass: "icon ni ni-clock" })]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showHistory
                    ? _c(
                        "div",
                        { staticClass: "sipinor-ai-history-pop" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "sipinor-ai-history-pop__new",
                              attrs: { type: "button" },
                              on: { click: _vm.startNewChat },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.trans(
                                      "configuration.ai_assistant_new_chat"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.threadHistory.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "sipinor-ai-history-pop__empty",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.trans(
                                          "configuration.ai_assistant_no_saved_chats"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "sipinor-ai-history-pop__note" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.trans(
                                      "configuration.ai_assistant_history_device_note"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.threadHistory, function (h) {
                            return _c(
                              "button",
                              {
                                key: h.id,
                                staticClass: "sipinor-ai-history-item",
                                attrs: { type: "button", title: h.title },
                                on: {
                                  click: function ($event) {
                                    return _vm.loadThread(h)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(h.title) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sipinor-ai-panel__body" }, [
                  _c(
                    "div",
                    { ref: "scrollArea", staticClass: "sipinor-ai-messages" },
                    [
                      _vm._l(_vm.messages, function (m, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "sipinor-ai-msg",
                            class: "sipinor-ai-msg--" + m.role,
                          },
                          [
                            m.role === "user"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "sipinor-ai-msg__bubble sipinor-ai-msg__bubble--user",
                                    class: {
                                      "sipinor-ai-msg__bubble--user-with-media":
                                        _vm.userAttachmentThumbs(m).length,
                                    },
                                  },
                                  [
                                    _vm.userAttachmentThumbs(m).length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "sipinor-ai-attach-strip sipinor-ai-attach-strip--sent",
                                          },
                                          _vm._l(
                                            _vm.userAttachmentThumbs(m),
                                            function (src, j) {
                                              return _c(
                                                "button",
                                                {
                                                  key: j,
                                                  staticClass:
                                                    "sipinor-ai-attach-strip__hit",
                                                  attrs: {
                                                    type: "button",
                                                    title: _vm.trans(
                                                      "configuration.ai_assistant_image_preview"
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.openAttachmentPreview(
                                                        _vm.userAttachmentFullSrc(
                                                          m,
                                                          j
                                                        ) || src
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "sipinor-ai-attach-strip__thumb",
                                                    attrs: {
                                                      src: src,
                                                      alt: "",
                                                    },
                                                    on: {
                                                      load: _vm.scrollBottom,
                                                    },
                                                  }),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.userMessageDisplayText(m)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "sipinor-ai-msg__text",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.userMessageDisplayText(m)
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    m.screenCapture
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "sipinor-ai-screen-badge",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.trans(
                                                    "configuration.ai_assistant_screen_badge"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "sipinor-ai-msg__assistant-wrap",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "sipinor-ai-msg__avatar-mini",
                                        attrs: { "aria-hidden": "true" },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              viewBox: "0 0 24 24",
                                              width: "14",
                                              height: "14",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M12 2a4 4 0 0 1 4 4v1a4 4 0 1 1-8 0V6a4 4 0 0 1 4-4z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "sipinor-ai-msg__bubble sipinor-ai-msg__bubble--assistant sipinor-ai-msg__bubble--rich",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatAssistantHtml(m.content)
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.loading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "sipinor-ai-msg sipinor-ai-msg--assistant",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "sipinor-ai-msg__assistant-wrap",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "sipinor-ai-msg__avatar-mini",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            viewBox: "0 0 24 24",
                                            width: "14",
                                            height: "14",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M12 2a4 4 0 0 1 4 4v1a4 4 0 1 1-8 0V6a4 4 0 0 1 4-4z",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "sipinor-ai-msg__bubble sipinor-ai-msg__bubble--assistant sipinor-ai-typing",
                                      attrs: { "aria-live": "polite" },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "sipinor-ai-typing__dot",
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "sipinor-ai-typing__dot",
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "sipinor-ai-typing__dot",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.showActionSuggestedPrompts &&
                  _vm.actionPromptLangKeys.length
                    ? _c("div", { staticClass: "sipinor-ai-action-prompts" }, [
                        _c(
                          "p",
                          { staticClass: "sipinor-ai-action-prompts__heading" },
                          [_vm._v(_vm._s(_vm.actionPromptsSectionTitle))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "sipinor-ai-action-prompts__chips",
                            attrs: { role: "list" },
                          },
                          _vm._l(_vm.actionPromptLangKeys, function (key) {
                            return _c(
                              "button",
                              {
                                key: key,
                                staticClass: "sipinor-ai-action-prompts__chip",
                                attrs: {
                                  type: "button",
                                  role: "listitem",
                                  disabled: _vm.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectActionPrompt(key)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.actionPromptLabel(key)) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "sipinor-ai-compose",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.send()
                        },
                      },
                    },
                    [
                      _c("input", {
                        ref: "imageFileInput",
                        staticClass: "sipinor-ai-file-input",
                        attrs: {
                          type: "file",
                          accept: "image/jpeg,image/png,image/webp",
                          multiple: "",
                        },
                        on: { change: _vm.onImageFilesSelected },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "sipinor-ai-compose__field" }, [
                        _vm.pendingImages.length
                          ? _c(
                              "div",
                              {
                                staticClass: "sipinor-ai-compose__attachments",
                                attrs: {
                                  role: "group",
                                  "aria-label": _vm.trans(
                                    "configuration.ai_assistant_pending_capture"
                                  ),
                                },
                              },
                              _vm._l(_vm.pendingImages, function (img) {
                                return _c(
                                  "div",
                                  {
                                    key: img.id,
                                    staticClass:
                                      "sipinor-ai-compose__attach-item",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "sipinor-ai-compose__attach-hit",
                                        attrs: {
                                          type: "button",
                                          title: _vm.trans(
                                            "configuration.ai_assistant_image_preview"
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openAttachmentPreview(
                                              img.previewDataUrl
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "sipinor-ai-compose__attach-thumb",
                                          attrs: {
                                            src: img.previewDataUrl,
                                            alt: "",
                                          },
                                          on: { load: _vm.scrollBottom },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "sipinor-ai-compose__attach-remove",
                                        attrs: {
                                          type: "button",
                                          title: _vm.trans("general.remove"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.removePendingImage(
                                              img.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("em", {
                                          staticClass: "icon ni ni-cross",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("textarea", {
                          ref: "draftInput",
                          staticClass: "sipinor-ai-textarea",
                          attrs: {
                            rows: "2",
                            maxlength: "4000",
                            placeholder: _vm.trans(
                              "configuration.ai_assistant_placeholder"
                            ),
                            disabled: _vm.loading,
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.draft },
                          on: {
                            input: _vm.onDraftInput,
                            keydown: _vm.onDraftKeydown,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sipinor-ai-compose__actions" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "sipinor-ai-icon-btn",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _vm.loading ||
                                    _vm.capturingScreen ||
                                    _vm.pendingImages.length >= 5,
                                  title: _vm.trans(
                                    "configuration.ai_assistant_capture_screen"
                                  ),
                                },
                                on: { click: _vm.captureScreen },
                              },
                              [_c("em", { staticClass: "icon ni ni-camera" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sipinor-ai-icon-btn",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _vm.loading ||
                                    _vm.pendingImages.length >= 5,
                                  title: _vm.trans(
                                    "configuration.ai_assistant_attach_images"
                                  ),
                                },
                                on: { click: _vm.openImagePicker },
                              },
                              [_c("em", { staticClass: "icon ni ni-upload" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "sipinor-ai-send",
                                attrs: {
                                  type: "submit",
                                  disabled:
                                    _vm.loading ||
                                    (!_vm.canSendContent &&
                                      !_vm.pendingImages.length),
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans(
                                        "configuration.ai_assistant_send"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("em", { staticClass: "icon ni ni-send" }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "sipinor-ai-compose__kbd-hint" }, [
                        _vm._v(
                          _vm._s(
                            _vm.trans(
                              "configuration.ai_assistant_multiline_hint"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sipinor-ai-fab",
              class: {
                "sipinor-ai-fab--open": _vm.panelOpen,
                "sipinor-ai-fab--action": _vm.mode === "action",
              },
              attrs: {
                type: "button",
                title: _vm.trans("configuration.ai_assistant"),
              },
              on: { click: _vm.toggleFab },
            },
            [
              !_vm.panelOpen
                ? _c("em", { staticClass: "icon ni ni-chat-circle" })
                : _c("em", { staticClass: "icon ni ni-cross" }),
            ]
          ),
          _vm._v(" "),
          _vm.attachmentPreviewSrc
            ? _c(
                "div",
                {
                  staticClass: "sipinor-ai-lightbox",
                  attrs: {
                    role: "dialog",
                    "aria-label": _vm.trans(
                      "configuration.ai_assistant_image_preview"
                    ),
                  },
                },
                [
                  _c("div", {
                    staticClass: "sipinor-ai-lightbox__backdrop",
                    on: { click: _vm.closeAttachmentPreview },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sipinor-ai-lightbox__frame",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "sipinor-ai-lightbox__close",
                          attrs: {
                            type: "button",
                            title: _vm.trans(
                              "configuration.ai_assistant_close_preview"
                            ),
                            "aria-label": _vm.trans(
                              "configuration.ai_assistant_close_preview"
                            ),
                          },
                          on: { click: _vm.closeAttachmentPreview },
                        },
                        [_c("em", { staticClass: "icon ni ni-cross" })]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "sipinor-ai-lightbox__img",
                        attrs: { src: _vm.attachmentPreviewSrc, alt: "" },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }